export const navbar = [
  {
    title: 'Homeoffice',
    path: 'https://www.sipgate.de/homeoffice',
  },
  {
    title: 'Produkte',
    path: 'https://www.sipgate.de/produkte',
  },
  {
    title: 'Über uns',
    path: 'https://www.sipgate.de/wir-sind-sipgate',
  },
  {
    title: 'Jobs',
    path: 'https://www.sipgate.de/jobs',
  },
  {
    title: 'Besuch',
    path: 'https://www.sipgate.de/besuch',
  },
  {
    title: 'Blog',
    path: 'https://www.sipgate.de/blog',
  },
];

export const menuItems = [
  {
    title: 'Marketing',
    path: 'Marketing',
    cName: 'dropdown-link',
  },
  {
    title: 'Consulting',
    path: 'Consulting',
    cName: 'dropdown-link',
  },
  {
    title: 'Design',
    path: 'Design',
    cName: 'dropdown-link',
  },
  {
    title: 'Development',
    path: 'Development',
    cName: 'dropdown-link',
  },
];

export const footerApi = [
  {
    title: 'sipgate',
    listing: ['Über uns', 'Besuch', 'Jobs', 'Unsere Speaker', 'Events', 'Blog'],
    links: [
      'https://www.sipgate.de/wir-sind-sipgate',
      'https://www.sipgate.de/besuch',
      'https://www.sipgate.de/jobs',
      'https://www.sipgate.de/speaker',
      'https://www.sipgate.de/veranstaltungen',
      'https://www.sipgate.de/blog',
    ],
  },
  {
    title: 'Produkte',
    listing: [
      'sipgate basic',
      'sipgate team',
      'simquadrat',
      'sipgate team mobil',
      'sipgate trunking',
      'sipgate.io',
    ],
    links: [
      'https://www.sipgatebasic.de',
      'https://www.sipgateteam.de',
      'https://www.simquadrat.de/',
      'https://www.sipgateteam.de',
      'https://www.sipgatetrunking.de',
      'https://www.sipgate.io',
    ],
  },
  {
    title: 'Rechtliches',
    listing: ['AGB', 'Datenschutz', 'Impressum'],
    links: [
      'https://www.sipgate.de/agb',
      'https://www.sipgate.de/datenschutz',
      'https://www.sipgate.de/impressum',
    ],
  },
  {
    title: 'Netzwerk',
    listing: [
      'Facebook',
      'Twitter',
      'Instagram',
      'Linkedin',
      'Xing',
      'Youtube',
      'Github',
      'RSS Feed',
    ],
    links: [
      'https://www.facebook.com/sipgate/',
      'https://twitter.com/sipgatede',
      'https://www.instagram.com/sipgate/',
      'https://www.linkedin.com/company/sipgate-gmbh/',
      'https://www.xing.com/companies/sipgategmbh',
      'https://www.youtube.com/user/sipgateDeutschland',
      'https://github.com/sipgate',
      'https://www.sipgate.de/feed.xml',
    ],
  },
];
